export default __webpack_public_path__ + "static/media/dream-doer.7099e9d8.png";